import { useMemo, createRef, useCallback, useEffect } from 'react';
import { observe } from 'react-intersection-observer';

const getRefKey = (item) => `${item.text}${item.href}`;
const useCreateIntersectionObserverRefs = (props) => {
    const { items, onChange, options: optionsOutput } = props;
    const refs = useMemo(() => items.reduce((acc, item) => {
        const ref = createRef();
        return {
            ...acc,
            [getRefKey(item)]: ref,
        };
    }, {}), [items]);
    const options = useMemo(() => ({
        // проблема на стороне сафари
        // на гитхабе в проекте react-intersection-observer был похожий вопрос о проблемах с treshold и safari
        // issue: https://github.com/thebuilder/react-intersection-observer/issues/621
        threshold: 0.9,
        ...optionsOutput,
    }), [optionsOutput]);
    const handleIntersectionChange = useCallback((index) => (inView, entry) => {
        onChange({
            inView,
            item: items[index],
            index,
            entry,
        });
    }, [items, onChange]);
    useEffect(() => {
        const destroys = [];
        Object.values(refs).forEach((ref, index) => {
            if (!ref.current)
                return;
            const destroy = observe(ref.current, handleIntersectionChange(index), options, true);
            destroys.push(destroy);
        });
        return () => {
            destroys.forEach((destroy) => destroy());
        };
    }, [refs, items, handleIntersectionChange, options]);
    return {
        refs,
        getRefKey,
    };
};

export { useCreateIntersectionObserverRefs };
//# sourceMappingURL=useCreateIntersectionObserverRefs.js.map
